import React from "react";
import HeroSection from "../../components/Hero/HeroSection";
import CapabilitySection from "../../components/Hero/CapabilitySection";
import Transperency from "../../components/Hero/Transperency";
import FeaturesSection from "../../components/Hero/FeaturesSection";
import AssestEye from "../../components/Hero/AssestEye";
import Footer from "../../components/Hero/Footer";
import Navbar from "../../components/Hero/Navbar";
import CardStack from "../../components/Hero/CardStack";

const Homepage = () => {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <CardStack />
      <CapabilitySection />
      <Transperency />
      <FeaturesSection />
      <AssestEye />
      <Footer />
    </div>
  );
};

export default Homepage;
